export default __webpack_public_path__ + "static/media/carrosel03.6cf9c12a.png";